import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {foregroundColorValue} from '../../javascripts/modules/colors.js';
import {afterNextRender} from '@polymer/polymer/lib/utils/render-status';

class KeliHeader extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
      <style>
        :host {
          display: block;
          color: var(--keli-header-color);
          font-weight: var(--keli-header-font-weight, 400);
          font-size: var(--keli-header-font-size, medium);
          text-align: var(--keli-header-text-align, center);
        }
      </style>

      [[caption]]`;
  }

  static get is() {
    return 'keli-header';
  }

  static get properties() {
    return {
      align: {type: String, scopevar: true, observer: 'alignChanged'},
      bold: {type: Boolean, scopevar: true, observer: 'boldChanged'},
      caption: {type: String, scopevar: true},
      color: {type: String, scopevar: true, observer: 'colorChanged'},
      fontScale: {type: Number, scopevar: true, observer: 'fontScaleChanged'},
      isBlockPanelElement: {type: Boolean, value: true},
      keliControlTypes: {type: Array, value: ['layout-header']}
    }
  }

  boldChanged(newValue) {
    this.updateStyles({'--keli-header-font-weight': (newValue ? '700' : '400')});
  }

  alignChanged(newValue) {
    this.updateStyles({'--keli-header-text-align': newValue || ''});
  }

  colorChanged(newValue) {
    afterNextRender(this, () => {
      this.updateStyles({'--keli-header-color': foregroundColorValue(newValue, this)});
    });
  }

  fontScaleChanged(newValue) {
    const size = parseFloat(newValue);
    this.updateStyles({'--keli-header-font-size': (!isNaN(size) ? `${size}em` : '')});
  }
}

customElements.define(KeliHeader.is, KeliHeader);
export {KeliHeader};
